export const BUSINESS_TYPE_OPTIONS: { key: string; label: string }[] = [
  { key: "law_firm", label: "Law firms and partnership" },
  { key: "law_firm_network", label: "Law firms network" },
  { key: "media_agency", label: "Media agencies" },
  { key: "non_law_firm", label: "Non law firms" },
  { key: "patma", label: "PATMA" },
  { key: "scottish_stables", label: "Scottish stables" },
  { key: "bar_england_wales", label: "The Bar – England & Wales" },
  { key: "lpc_provider", label: "LPC Providers" },
  { key: "corporate_council", label: "Corporate Council" },
  { key: "government", label: "Government" },
  { key: "uk_inhouse_directory", label: "UK in-house lawyer directory" },
  { key: "uk_support_service_providers", label: "UK support service providers" },
  { key: "mediators_arbitrators", label: "Mediators and Arbitrators" },
  { key: "independent", label: "Independent" },
];
